import BatchProcessAttentionVehicleModal from './batch-process-attention-vehicle-modal.vue'
export default BatchProcessAttentionVehicleModal
